import React, { Fragment, FunctionComponent } from 'react'
import { reactular } from '@vendhq/reactular'
import { SaleProductSearch } from '../product/SaleProductSearch'
import { useQuickKeysManager } from '../../ng-compat/hooks'
import { QuickKeys } from '../quick-keys/QuickKeys'
import { AddProductToSaleModals } from '../AddProductToSale/AddProductToSaleModals'
import { TrainingModeModal } from '../../modals/TrainingModeModal'
import { useAppSelector } from '../../state/hooks'
import { selectActiveRegisterId } from '../../state/slices/posState/posStateSlice'

export const Workspace: FunctionComponent = () => {
  const quickKeysManager = useQuickKeysManager()
  const quickKeysEnabled = quickKeysManager.isQuickKeysEnabled()
  const registerId = useAppSelector(selectActiveRegisterId)

  return (
    <Fragment key={registerId}>
      <div className="wr-global-search">
        <SaleProductSearch />
      </div>
      {quickKeysEnabled ? (
        <div className="wr-workspace-module-container">
          <QuickKeys />
        </div>
      ) : null}
      <AddProductToSaleModals />
      {
        // TODO: Ideally this would be at the root of the sell screen but
        // that's basically a bunch of UI-views. Move it to a better place
        // when it exists.
      }
      <TrainingModeModal />
    </Fragment>
  )
}

export const WorkSpaceComponent = reactular(Workspace, [], 'reactWrapper')
